import React from "react";

const Loading: React.FC = () => {
  return <div>Loading...</div>;
};

export default Loading;
